import { cn } from '@workspace/ui/lib';
import type { HTMLAttributes, ReactNode } from 'react';

export function Card({
  className,
  children,
  onClick,
  ...props
}: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return (
    <div
      className={cn(
        'bg-grey-25 dark:bg-grey-1000 rounded-[32px] p-6 shadow-[0px_429px_120px_0px_rgba(42,43,65,0.00),0px_17px_38px_0px_rgba(42,43,65,0.05)] sm:rounded-4xl sm:p-8 lg:p-11',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}
